import { render, staticRenderFns } from "./number.vue?vue&type=template&id=47aede38&scoped=true&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aede38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47aede38')) {
      api.createRecord('47aede38', component.options)
    } else {
      api.reload('47aede38', component.options)
    }
    module.hot.accept("./number.vue?vue&type=template&id=47aede38&scoped=true&", function () {
      api.rerender('47aede38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/number.vue"
export default component.exports